import { InputHTMLAttributes } from "react";
import { useTheme } from "../hooks/useTheme";

interface FormContainerProps extends InputHTMLAttributes<HTMLDivElement> {

}

export default function FormContainer(props: FormContainerProps) {

    const { theme } = useTheme();
  
    return (
      <div className='border-2 border-round-xl px-5 p-4 bg-form' style={{ borderColor: theme.color.primary }} {...props}>
        {props.children}
      </div>
    );
  }